export default __webpack_public_path__ + "static/media/Sketch.491ac138.svg";